import * as React from "react"
import { useLanguageState } from "../../globalStates/LanguageState"
import { SubmitButtonContainer, SubmitButtonNew, DisagreeButton } from "./SayHelloModal"
import { IconClose } from "../Icons"
import branding from "../../branding/branding"
import styled from "styled-components"
import { Modal } from "react-bootstrap"

const ModalRoot = styled(Modal)`
    font-family: ${branding.font1};
    color: ${branding.mainInfoColor};

    svg {
        color: ${branding.primaryColor};
    }

    .close {
        text-shadow: none;
        color: ${branding.mainInfoColor};
        margin: -2rem -1rem -1rem auto;
    }

    .modal-dialog {
        width: 415px;
        top: 40%;
        transform: translateY(-50%);
    }

    .modal-header-close {
        outline: 0;
        position: absolute;
        right: 20px;
        top: 20px;
        font-size: 26px;
        font-weight: 10;
        line-height: 1.66666667;
        color: ${branding.mainInfoColor};
        width: 30px;
        padding: 0 4px;
        background: none;
        border-style: none;
        margin-right: 0px;
        margin-top: -10px;
    }

    .modal-content {
        font-family: ${branding.font1};
        padding: 0 20px;
        border-radius: 5px;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
    }

    .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        border: none;
        padding: 35px 0 10px 0;
    }
    .modal-footer {
        justify-content: space-between;
        border: none;
        padding: 0px 8px;
    }

    .modal-body {
        padding: 12px 15px 35px 15px;
        font-size: 12px;
        line-height: 12px;
    }

    .modal-title {
        font-family: ${branding.font1};
        margin-left: 15px;
        font-size: 18px;
        line-height: 17px;
        font-weight: bold;
        margin-top: 3px;
    }

    .btn-primary {
        font-family: ${branding.font1};
        width: 30%;
        display: inline;
        background-color: ${branding.sayHelloModal.submitBtnPrimaryBgColor ?? "#000"};
        color: ${branding.sayHelloModal.submitBtnPrimaryTextColor ?? "#fff"};
        /* border: 1px solid ${branding.sayHelloModal.submitBtnPrimaryBorderColor ?? "#000"};
        border-radius: 5px; */

        :hover {
            background-color: ${branding.sayHelloModal.submitBtnPrimaryOnHoverBgColor ?? "#e8e8e8"} !important;
            color: ${branding.sayHelloModal.submitBtnPrimaryOnHoverTextColor ?? "#000"} !important;
        }
    }

    & .btn-primary:focus {
        outline: none !important;
    }

    .btn-secondary {
        display: inline;
        width: 30%;
        font-family: ${branding.font1};
        color: ${branding.sayHelloModal.submitBtnSecondaryTextColor ?? "#000"} !important;
        background-color: ${branding.sayHelloModal.submitBtnSecondaryBgColor ?? "#fff"};
        border: none;
        border-color: ${branding.sayHelloModal.submitBtnSecondaryBorderColor ?? "#fff"};
        border-radius: none;
    }

    & .btn-secondary:focus {
        outline: none !important;
    }
    .subtitleText {
        font-family: ${branding.font1};
        display: absolute;
        align-items: center;
        font-size: 14px;
        line-height: 18px;
        margin: 10px 15px 25px 15px;
    }

    .headerImage {
        margin-top: 5px;
        margin-left: 15px;
    }

    .customString {
        font-weight: bold;
    }

    .messageBox {
        display: flex;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 18px;
        /* margin-left: 8px; */
        font-family: ${branding.font1};
    }
`

interface MuteAllModalProps {
    muteAllParticipants: () => void
    onClose: () => void
}

const MuteAllModal: React.FunctionComponent<MuteAllModalProps> = (props: MuteAllModalProps) => {
    const strings = useLanguageState().getStrings()

    function handleClose() {
        props.onClose()
    }

    function handleMuteAll() {
        props.muteAllParticipants()
    }

    return (
        <ModalRoot backdrop="static" show={true} animation={false}>
            <div onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h3 className="modal-title">{strings.roster.muteAllModalTitle}</h3>
                    <button type="button" className="close" onClick={() => handleClose()} aria-label="Close">
                        {IconClose({ fill: branding.sideIconBar.sideIconColorDark, width: "15", height: "15" })}
                    </button>
                </div>

                <div className="modal-body">{strings.roster.muteAllModalText}</div>
                <div className="modal-footer">
                    <SubmitButtonContainer>
                        <DisagreeButton onClick={() => handleClose()} className="d-flex align-items-center">
                            {strings.roster.muteAllModalCloseButtonText}
                        </DisagreeButton>
                        <SubmitButtonNew
                            type="submit"
                            onClick={() => handleMuteAll()}
                            className="d-flex align-items-center justify-content-center"
                        >
                            {strings.roster.muteAllModalContinueButtonText}
                        </SubmitButtonNew>
                    </SubmitButtonContainer>
                </div>
            </div>
        </ModalRoot>
    )
}

export default MuteAllModal
